// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"5bb1c64c","187":"56f095c4","419":"5f301a82","563":"1d645fe9","942":"714a3f3e"}[chunkId] + ".chunk.js";
};